<template>
  <div>
    <ca-loader v-if="showLoading"></ca-loader>
    <ca-form
      v-else
      ref="form"
      :key="formKey"
      :on-submit="() => {}"
      :is-valid.sync="isFormValid">
      <ca-row vertical-offset="4">
        <ca-col>
          <ca-heading text="Dados básicos" size="medium"></ca-heading>
        </ca-col>
      </ca-row>
      <ca-row-divider margin-bottom="medium"></ca-row-divider>
      <worker-basic-data-form
        :basic-data="workerContractData.basicInfo"
        @refresh-form="refreshForm"></worker-basic-data-form>

      <ca-row vertical-offset="4">
        <ca-col>
          <ca-heading text="Trabalhistas" size="medium"></ca-heading>
        </ca-col>
      </ca-row>
      <ca-row-divider margin-bottom="medium"></ca-row-divider>
      <worker-job-info-form
        :job-info="workerContractData.workInfo"
        @refresh-form="refreshForm"></worker-job-info-form>

      <ca-row vertical-offset="4">
        <ca-col>
          <ca-heading text="Contrato" size="medium"></ca-heading>
        </ca-col>
      </ca-row>
      <ca-row-divider margin-bottom="medium"></ca-row-divider>
      <worker-contract-info-form
        :contract-info="workerContractData.contractInfo"
        @refresh-form="refreshForm"></worker-contract-info-form>

      <ca-row vertical-offset="4">
        <ca-col>
          <ca-heading text="Jornada" size="medium"></ca-heading>
        </ca-col>
      </ca-row>
      <ca-row-divider margin-bottom="medium"></ca-row-divider>
      <worker-shift-info-form
        :is-weekly-journey.sync="isWeeklyJourney"
        :shift-info="workerContractData.shiftInfo"
        :variable-shift="workerContractData.variableShift"
        :journey-type="workerContractData.journeyType"
        :is-draft="true"
        @set-shift-info="setShiftInfo"
        @refresh-form="refreshForm"></worker-shift-info-form>
    </ca-form>
  </div>
</template>

<script>
import { initFormObject } from 'packages/common';
import WorkerContractInfoForm from 'accountant/worker/src/modules/workers/components/contract-info/WorkerContractInfoForm';
import WorkerBasicDataForm from 'accountant/worker/src/modules/workers/components/basic-data-form/WorkerBasicDataForm';
import WorkerJobInfoForm from 'accountant/worker/src/modules/workers/components/info-job/WorkerJobInfoForm';
import WorkerShiftInfoForm from 'accountant/worker/src/modules/workers/components/shift-info/components/WorkerShiftInfoForm';
import { getVariableShift, hasJourneyType, isWeeklyJourney } from 'accountant/worker/src/modules/workers/components/shift-info/workerShiftInfoService';
import {
  getShiftInfo,
  mapShiftInfo,
  getWorkerDraft,
  setWorkerDraft,
} from '../../../../workersService';
import store from '../../../../../../store/index';

const DEFAULT_JOURNEY_TYPE = { name: 'F' };
const DEFAULT_SHIFT_INFO = {
  weeklyHours: null,
  associatedWorkshifts: [],
};

export default {
  name: 'WorkerContractDataForm',
  components: {
    WorkerBasicDataForm,
    WorkerJobInfoForm,
    WorkerContractInfoForm,
    WorkerShiftInfoForm,
  },
  data() {
    return {
      formKey: 0,
      isFormValid: true,
      showLoading: true,
      workerContractData: {
        basicInfo: { ...store.state.worker.basicInfo },
        workInfo: {
          ...initFormObject([
            { workingType: 'C' },
            { workingHoursType: 'S' },
            { pensionType: 'G' },
            { natureActivityWork: 'U' },
            { agentExposureType: 'N' },
            { category: 'O101' },
            { anotherCompanyInformation: 'S' },
          ]),
          baseDate: null,
        },
        contractInfo: {
          ...initFormObject([
            { contractType: 'I' },
            { admissionType: 'A' },
            { admissionIndicator: 'N' },
            { temporaryLegalType: 'N' },
            { temporaryInclusion: 'L' },
            { salaryUnit: 'M' },
          ]),
          fgts: true,
          dsr: true,
          temporary: false,
          unionContribution: false,
        },
        shiftInfo: mapShiftInfo(DEFAULT_SHIFT_INFO),
        variableShift: {},
        journeyType: DEFAULT_JOURNEY_TYPE,
      },
    };
  },
  computed: {
    workerDraft() {
      return getWorkerDraft();
    },
    workerBasicInfo() {
      return store.state.worker.basicInfo;
    },
    workerId() {
      return this.workerBasicInfo.id;
    },
    isWeeklyJourney() {
      return isWeeklyJourney(this.workerContractData.journeyType);
    },
  },
  watch: {
    isFormValid(value) {
      this.$emit('on-is-form-valid', value);
    },
    workerContractData: {
      deep: true,
      handler(value) {
        this.$emit('update-contract-data', value);
      },
    },
  },
  created() {
    this.initData();
  },
  methods: {
    async initData() {
      await store.dispatch('worker/getWorkerContractInfo', this.workerId);
      await store.dispatch('worker/getWorkerJobInfo', this.workerId);
      await store.dispatch('breadcrumb/setBreadcrumbProps', {
        workerName: this.workerBasicInfo.name,
      });

      this.setWorkerData();
      this.setInitialShiftInfo();
      // TODO; remover após resolver prob. de validação do input salário em WorkerContractInfoForm
      this.refreshForm();
      this.showLoading = false;
    },
    async setInitialShiftInfo() {
      try {
        const response = await getShiftInfo(this.workerId);

        if (response.journeyType?.name) {
          this.workerContractData.journeyType = response.journeyType;
        }

        this.workerContractData.shiftInfo = this.isWeeklyJourney
          ? mapShiftInfo(response)
          : response;

        this.workerContractData.variableShift.workshiftId = getVariableShift(
          this.isWeeklyJourney,
          this.workerContractData.shiftInfo
        );

        setWorkerDraft({
          workshiftInfo: {
            journeyType: this.workerContractData.journeyType,
            ...this.workerContractData.shiftInfo,
          },
        });
      } catch (error) {
        this.$toaster.error('Aconteceu um erro, por favor tente novamente.');
      } finally {
        this.showLoading = false;
      }
    },
    setShiftInfo() {
      const workshiftInfo = this.workerDraft.workshiftInfo || DEFAULT_SHIFT_INFO;

      this.workerContractData.journeyType = hasJourneyType(workshiftInfo)
        ? workshiftInfo.journeyType
        : DEFAULT_JOURNEY_TYPE;

      this.workerContractData.shiftInfo = this.isWeeklyJourney
        ? mapShiftInfo(workshiftInfo)
        : workshiftInfo;

      this.workerContractData.variableShift.workshiftId = getVariableShift(
        this.isWeeklyJourney,
        this.shiftInfo
      );
    },
    setWorkerData() {
      const { contractInfo, jobInfo } = store.state.worker;
      this.workerContractData.contractInfo = contractInfo;
      this.workerContractData.workInfo = jobInfo;
    },
    clearShiftInfo() {
      this.workerContractData.shiftInfo.weeklyHours = null;
      this.workerContractData.variableShift.workshiftId = null;
    },
    async refreshForm() {
      this.formKey++;
      await this.$nextTick();
      if (this.$refs?.form.isValid) {
        this.isFormValid = this.$refs.form.isValid;
      }
    },
  },
};
</script>
